"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTo12Hour = exports.convertTo24Hour = void 0;
function convertTo24Hour(timeStr) {
    if (!timeStr) {
        return null;
    }
    /* eslint-disable prefer-const */
    const [time, modifier] = timeStr.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (modifier === 'PM' && hours < 12) {
        hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
        hours = 0;
    }
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');
    return `${hh}:${mm}`;
}
exports.convertTo24Hour = convertTo24Hour;
function convertTo12Hour(timeStr) {
    if (!timeStr) {
        return null;
    }
    /* ts-ignore prefer-const */
    let [hour, minute] = timeStr.split(':').map(Number);
    const modifier = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    if (hour === 0) {
        hour = 12;
    }
    const hh = hour.toString();
    const mm = minute.toString().padStart(2, '0');
    return `${hh}:${mm} ${modifier}`;
}
exports.convertTo12Hour = convertTo12Hour;
